if (!customElements.get('youtube-reviews')) {
  customElements.define(
    'youtube-reviews',
    class YoutubeReviews extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.frame = this.querySelector('[data-youtube-frame]');

        // The marquee repeats every card in hidden tracks; keep those out of the tab order.
        this.querySelectorAll('[aria-hidden="true"] a').forEach((link) => link.setAttribute('tabindex', '-1'));

        this.addEventListener('click', this.onClick.bind(this));
        this.querySelector('[data-youtube-close]').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => {
          // The close event fires async; skip if another video was opened meanwhile.
          if (this.dialog.open) return;
          this.frame.replaceChildren();
          document.body.style.overflow = '';
        });
      }

      onClick(event) {
        const link = event.target.closest('a[data-youtube-id]');
        if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey) return;
        if (typeof this.dialog.showModal !== 'function') return;

        event.preventDefault();
        const { youtubeId, youtubeKind, youtubeTitle, youtubeChannel } = link.dataset;

        const iframe = document.createElement('iframe');
        iframe.src = `https://www.youtube-nocookie.com/embed/${youtubeId}?autoplay=1&rel=0&playsinline=1`;
        iframe.title = youtubeTitle;
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        iframe.allowFullscreen = true;
        this.frame.replaceChildren(iframe);

        this.dialog.classList.toggle('is-short', youtubeKind === 'short');
        this.querySelector('[data-youtube-caption-title]').textContent = youtubeTitle;
        this.querySelector('[data-youtube-caption-channel]').textContent = youtubeChannel;
        this.querySelector('[data-youtube-caption-link]').href = link.href;

        document.body.style.overflow = 'hidden';
        this.dialog.showModal();
      }
    }
  );
}
